import React, { createContext, useState, useContext, useEffect } from 'react';

// Define shape of user data
const defaultUser = {
    id: null,
    name: '',
    email: '',
    role: '',
    token: '',
    isVerified: false
};

const UserContext = createContext({
    user: defaultUser,
    isLoading: true,
    isAuthenticated: false,
    login: () => { },
    logout: () => { },
    updateUser: () => { }
});

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(defaultUser);
    const [isLoading, setIsLoading] = useState(true);

    // Load user from localStorage on initial render
    useEffect(() => {
        const loadUser = async () => {
            try {
                const storedUser = localStorage.getItem('myToken');
                if (storedUser) {
                    console.log(storedUser, "from context")
                    const parsedUser = JSON.parse(storedUser);

                    const userWithVerifiedStatus = {
                        ...parsedUser,
                        isVerified: parsedUser.role === "admin"
                    }
                    setUser(userWithVerifiedStatus);
                }
            } catch (error) {
                console.error('Failed to parse user data', error);
            } finally {
                setIsLoading(false);
            }
        };

        loadUser();
    }, []);

    const login = (userData) => {
        const isVerified = userData.role === "admin";

        const completeUser = {
            ...defaultUser,
            ...userData,
            isVerified,
            isAuthenticated: true,
            lastLogin: new Date().toISOString()
        };

        setUser(completeUser);
        localStorage.setItem('myToken', JSON.stringify(completeUser));
    };

    const logout = () => {
        setUser(defaultUser);
        localStorage.removeItem('myToken');
        // Optional: Add API call to invalidate token
    };

    const updateUser = (updatedData) => {
        const updatedUser = {
            ...user,
            ...updatedData,
            ...(updatedData.role && { isVerified: updatedData.role === "admin" })
        };
        setUser(updatedUser);
        localStorage.setItem('myToken', JSON.stringify(updatedUser));
    };

    const value = {
        user,
        isLoading,
        isAuthenticated: !!user?.id,
        login,
        logout,
        updateUser
    };

    return (
        <UserContext.Provider value={value}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
};